// Google Tag Manager and Google Analytics (gtag) bootstrap. Bundled instead of
// inline <script> blocks so the site can run under a Content-Security-Policy
// without 'unsafe-inline'. The gtag.js library itself stays an external
// <script async> tag in the scripts partials.
const GTM_ID = "GTM-TXQMRWL";
const GA_ID = "G-XVW7SKGBZ6";

window.dataLayer = window.dataLayer || [];

// Google Tag Manager
window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
const gtm = document.createElement("script");
gtm.async = true;
gtm.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
document.head.appendChild(gtm);

// Google Analytics: gtag() must push the `arguments` object, as Google's snippet does.
window.gtag = function gtag() {
  window.dataLayer.push(arguments);
};
window.gtag("js", new Date());
window.gtag("config", GA_ID);
